export default {
  primaryFont: 'Montserrat, fallback-font, sans-serif',
  secondaryFont: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  topbar: 60,
  teamMenuBar: 56,
  indexes: {
    topbar: 3,
    modal: 4,
    menu: 1,
    profilesFilter: 5, // We need to positionize above DescriptionMenu
    sidenavTeams: 2,
    sidenavMembers: 1,
    cancelButton: 2,
    buttonGroupSliderSelected: 1,
    cookieBanner: 3,
  },
  media: {
    small: '600px',
    medium: '900px',
    // large: '900px',
    large: '1080px',
    // large: '1120px',
  },
}
